module.exports = __webpack_public_path__ + "static/media/galerija_2017 (38).19606aa9.jpg";